const ProjectAction = {
  project: "",
  action: "",
  project_pos: 0.0,
};

export default ProjectAction;